import CustomerInformation from '@features/customers/components/CustomerInformation';
import { MenuState } from '@features/main/interfaces/main.interfaces';
import { ClienteSuite } from '@interfaces/firestore-documents.interfaces';
import { CircularProgress, Theme, useMediaQuery } from '@mui/material';
import NoResults from '../../components/NoResults';
import {
	DivisionInformation,
	DivisionsContainer,
	SingleDivisionContainer,
} from '@features/divisions';
import useSingleCustomerContainerStyles from './SingleCustomerContainer.styles';
import { Cities } from '@features/customers/interfaces/search.interfaces';

interface Props {
	data: ClienteSuite | null;
	divisionNumber: string;
	loading: boolean;
	menuState: MenuState;
	searchText: string;
	cities: Cities[];
	getDataById: (identificacion: string) => Promise<void>;
	setDivisionNumber: React.Dispatch<React.SetStateAction<string>>;
}

const SingleCustomerContainer: React.FC<Props> = ({
	data,
	divisionNumber,
	loading,
	menuState,
	searchText,
	setDivisionNumber,
	cities,
	getDataById,
}) => {
	// Hooks
	const classes = useSingleCustomerContainerStyles();

	// Breakpoints
	const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

	if (loading) {
		return (
			<div className={classes.loadingContainer}>
				<CircularProgress />
			</div>
		);
	}

	if (!loading && data == null) {
		return <NoResults searchText={searchText} />;
	}

	if (data == null) return null;

	const divisionData = data.divisiones.find((x) => x.codigo_div === divisionNumber) ?? null;

	return (
		<div className={classes.root} id="customer-information-container">
			<div
				className={classes.leftContainer}
				id="customer-information-container-left"
				style={{ width: isSmallScreen ? '100%' : 242 }}
			>
				{divisionData != null && <DivisionInformation data={divisionData} />}
				<CustomerInformation data={data} />
			</div>
			<div
				id="customer-information-container-right"
				style={{ width: isSmallScreen ? '100%' : 'calc(100% - 242px)' }}
			>
				{divisionData ? (
					<SingleDivisionContainer
						data={divisionData}
						getDataById={getDataById}
						allData={data}
						cities={cities}
						nit={data.identificacion}
						setDivisionNumber={setDivisionNumber}
					/>
				) : (
					<DivisionsContainer
						data={data}
						menuState={menuState}
						setDivisionNumber={setDivisionNumber}
					/>
				)}
			</div>
		</div>
	);
};

export default SingleCustomerContainer;
